import React from 'react';

const CommencementDate = () => (
  <div>
    <p>The commencement date of your project will be confirmed upon your purchase. Typically this will be within 1-2 weeks from the time of your purchase.</p>
  </div>
);

export default CommencementDate; 